module.exports = __webpack_public_path__ + "assets/img/652700.33399eaf.png";